import { forwardRef, type Ref, type SVGProps } from "react";
const IconFilterOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M7 11h2a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h2V3a1 1 0 0 1 2 0zm-2 6a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0zm11 0a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v13a1 1 0 0 0 1 1m-4 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-2v7a1 1 0 1 1-2 0v-7h-2a1 1 0 0 1-1-1m14-5a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0V17a1 1 0 0 0-1-1m1-5h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V3a1 1 0 1 1 2 0z" />
  </svg>
);
const ForwardRef = forwardRef(IconFilterOutlineSVG);
ForwardRef.displayName = "IconFilterOutline";
export { ForwardRef as IconFilterOutline };
